/**
 * Montserrat font is enforced globally via CSS (* { font-family: 'Montserrat' !important; }).
 * Heavy JS DOM iteration removed to prevent main-thread CPU lockup and white screen rendering freezes.
 */

const applyMontserratToAllElements = () => {
  // CSS rules in index.html and force-montserrat.css handle font enforcement globally
};

export default applyMontserratToAllElements;
